import { MenuNavItemValue } from '@components'

import { ButtonDropdown, NavItem, useModal } from '@billy/design-system'
import { ReactElement, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../enums/modalId'
import { useSegment } from '../../../../hooks'
import { ProductsExportDrawer } from '../ProductsExportDrawer'

enum ProductsActionId {
  Import = 'import',
  Export = 'export',
}

export const ProductsActions = (): ReactElement => {
  const [isExportDrawerOpen, setIsExportDrawerOpen] = useState(false)
  const { t } = useTranslation()
  const { track } = useSegment()
  const { open: openImportModal } = useModal(ModalId.ProductsImportModal)

  const moreButtonItems: NavItem<MenuNavItemValue>[] = useMemo(
    () => [
      {
        id: ProductsActionId.Export,
        children: t('products.actions.export_items'),
        value: undefined,
      },
      {
        id: ProductsActionId.Import,
        children: t('products.actions.import_items'),
        value: undefined,
      },
    ],
    [t],
  )

  const handleMoreSelect = useCallback(
    (id: string) => {
      track('XXX - Invoicing Core - Item lists - More menu option clicked', { option: id })

      if (id === ProductsActionId.Import) {
        openImportModal()
        return
      }

      if (id === ProductsActionId.Export) {
        setIsExportDrawerOpen(true)
      }
    },
    [openImportModal, track],
  )

  const handleExportDrawerClose = useCallback(() => {
    setIsExportDrawerOpen(false)
  }, [])

  return (
    <>
      <ButtonDropdown<MenuNavItemValue> items={moreButtonItems} onSelect={handleMoreSelect} variant="outlined">
        {t('more')}
      </ButtonDropdown>
      <ProductsExportDrawer isOpen={isExportDrawerOpen} onClose={handleExportDrawerClose} />
    </>
  )
}
